import { FC } from 'react';
import { TagEl } from './styles';

export const Tag: FC = ({ children }) => <TagEl>{children}</TagEl>;
